var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEpink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 360,
    viewBox: "0 0 640 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_1029)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "#F9F2EB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "#F9F2EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632 361.302L392.158 113.446L382.021 109.271C378.323 107.749 373.138 106 365.788 106C346.402 106 333.374 118.552 333.374 137.229V141.006H316.548V143.745C312.257 142.129 307.004 141.07 300.552 141.07C290.895 141.07 282.132 143.616 274.366 148.658C268.55 143.766 260.603 141.07 251.265 141.07C246.48 141.07 242.197 141.816 238.417 142.99V142.703H196.162L173 249.144L412.841 497H609.053V422.818H628.048V388.862H624.44L632.004 361.302H632Z",
    fill: "#FF004D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.552 153.463C286.974 153.463 278.425 159.996 272.725 166.366H271.553C269.877 160.489 264.847 153.463 251.269 153.463C240.204 153.463 232.828 158.689 226.961 164.733H225.62L225.788 155.096H206.174L188.404 236.751H209.86L220.423 188.246C222.936 177.139 231.823 171.587 239.366 171.587C246.909 171.587 252.442 177.139 250.096 187.92L239.366 236.751H260.822L271.385 188.409C273.563 178.12 281.441 171.587 290.328 171.587C298.206 171.587 303.572 176.813 301.394 187.264L290.496 236.746H311.952L323.52 183.835C327.88 163.747 318.49 153.459 300.556 153.459L300.552 153.463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.793 138.729C356.793 132.226 359.792 127.893 367.455 127.893C369.452 127.893 372.287 128.227 374.95 129.226L377.283 120.725C374.452 119.559 370.951 118.393 365.788 118.393C353.46 118.393 345.792 125.226 345.792 137.229V153.399H328.962V162.568H345.792V236.751H356.789V162.568H375.784V153.399H356.789V138.729H356.793Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_1029"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpink);
export default __webpack_public_path__ + "static/media/EPINK.3d7f1d6153d79601ce3907c108e63e51.svg";
export { ForwardRef as ReactComponent };